export default __webpack_public_path__ + "static/media/c2.6752a29c.jpg";